// extracted by mini-css-extract-plugin
export default {"box":"cancellationListPage_box__CXDPM"};